import { TreeSelectDataNode } from './types';

export const filterTreeNode = (inputValue: string, treeNode: TreeSelectDataNode) => {
  return treeNode.title!.toString().toLowerCase().includes(inputValue.toLowerCase());
};
